import {Injectable, OnDestroy} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {SmagApiService} from '../api/smag-api.service';
import {takeUntil} from 'rxjs/operators';
import {LoginService} from './login.service';
import {HierarchyService} from './hierarchy.service';


@Injectable()
export class CustomerCareService implements OnDestroy {

    private destroyed = new Subject<void>();
    private customerCareSubj: ReplaySubject<boolean>;

    constructor(private readonly apiService: SmagApiService,
                private readonly loginService: LoginService,
                private readonly hierarchyService: HierarchyService) {
        this.customerCareSubj = new ReplaySubject<boolean>(1); // like BehaviorSubject but with no need for initial value
        // reloadCustomerCare is triggered every time a user gets logged-in
        loginService.addSetupHook(1, profile => {
            console.debug(`Retrieving customer care for user ${profile?.username}`);
            return this.reloadCustomerCare();
        });

        loginService.logout.pipe(
            takeUntil(this.destroyed)
        ).subscribe(() =>
            this.customerCareSubj.next(false)
        );
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    get customerCare(): Observable<boolean> {
        return this.customerCareSubj.asObservable();
    }

    private reloadCustomerCare(): Promise<boolean> {
        return this.apiService.getCustomerConfig().toPromise()
            .then(cfg => {
                this.customerCareSubj.next(cfg.customer_care_enabled);
                return cfg.customer_care_enabled;
            });
    }
}

